// Generic accessible modal: scrim + centered card, Esc to close, focus moves in
// on open and returns to the previously focused element on close.
import React, { useEffect, useRef } from 'react';

export default function Modal({ children, label, onClose }) {
	const cardRef = useRef(null);

	useEffect(() => {
		const previous = document.activeElement;
		cardRef.current?.focus();
		document.body.style.overflow = 'hidden';
		const onKey = (e) => {
			if (e.key === 'Escape') onClose?.();
			// Minimal focus trap — cycle Tab within the card's focusable elements.
			if (e.key === 'Tab' && cardRef.current) {
				const focusables = cardRef.current.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
				if (!focusables.length) return;
				const first = focusables[0];
				const last = focusables[focusables.length - 1];
				if (e.shiftKey && document.activeElement === first) {
					e.preventDefault();
					last.focus();
				} else if (!e.shiftKey && document.activeElement === last) {
					e.preventDefault();
					first.focus();
				}
			}
		};
		window.addEventListener('keydown', onKey);
		return () => {
			window.removeEventListener('keydown', onKey);
			document.body.style.overflow = '';
			if (previous instanceof HTMLElement) previous.focus();
		};
	}, [onClose]);

	return (
		<div className='modal' onClick={onClose}>
			<div
				ref={cardRef}
				className='modal__card'
				role='dialog'
				aria-modal='true'
				aria-label={label}
				tabIndex={-1}
				onClick={(e) => e.stopPropagation()}>
				{children}
			</div>
		</div>
	);
}
